import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

export default class PersonCompanyBio extends Component {
  createBadge(url, badgeType, year, content) {
    const classNames = [
      'person-company-bio__badge',
      `person-company-bio__badge--${badgeType}-${year}`
    ].join(' ');
    const badge = `<a href="${url}" class="${classNames}">${content}</a>`;
    return badge;
  }

  renderBio(badge = '') {
    const { personOrCompany, isIBD } = this.props;
    return (
      <div
        className={`person-company-bio__bio-text ${
          isIBD ? 'person-company-bio__bio-text--ibd' : ''
        }`}
        dangerouslySetInnerHTML={{ __html: badge + personOrCompany.bio }}
      />
    );
  }

  renderCompanyBio() {
    const { awards } = this.props;
    const year = get(awards, `[0].year`, '');
    const url = `/most-innovative-companies/${year}`;
    const content = `<img class="badgetof" src="https://images.fastcompany.net/image/upload/v1551476809/fcweb/MIC_Inset_mzjwml.png" />`;

    return this.renderBio(this.createBadge(url, 'mic', year, content));
  }

  renderPersonBio() {
    const { personOrCompany } = this.props;
    const { year } = get(personOrCompany, `mcp100[0]`, '');
    let url = `/most-creative-people`;
    const content = `<img src="https://images.fastcompany.net/image/upload/v1556312218/fcweb/MCP-profile-badge_rfmyfx.png" alt="Most Creative People" />`;

    if (year) {
      url += `/${year}`;
      // content += ` <span>${year}</span>`;
    }

    return this.renderBio(this.createBadge(url, 'mcp', year || "default", content)); // eslint-disable-line
  }

  render() {
    const { personOrCompany, awards } = this.props;

    if (awards.length) {
      return this.renderCompanyBio();
    }

    if (personOrCompany.mcp) {
      return this.renderPersonBio();
    }
    return this.renderBio();
  }
}

PersonCompanyBio.defaultProps = {
  personOrCompany: {},
  isIBD: false,
  awards: []
};

PersonCompanyBio.propTypes = {
  personOrCompany: PropTypes.shape({}),
  isIBD: PropTypes.bool,
  awards: PropTypes.arrayOf(PropTypes.shape({}))
};
